import { IJob } from 'wisestep-api';
import create, { SetState } from 'zustand';

interface ISimilarJobsStore {
  jobs: ISimilarJobDetails | null;
  setSimilarJobs(args: IJob[]): void;
}

interface ISimilarJobDetails {
  jobIds: string[];
  jobCodes: string[];
}

export const useJobsStore = create<ISimilarJobsStore>((set: SetState<ISimilarJobsStore>) => ({
  jobs: null,
  setSimilarJobs: (jobs: IJob[]) =>
    set({
      jobs: {
        jobIds: jobs.map((job) => job.id ?? ''),
        jobCodes: jobs.map((job) => job.jobCode ?? ''),
      },
    }),
}));

export default useJobsStore;
